<script setup lang="ts">
import NavigationBar from "@/components/navigation/NavigationBar.vue";
import InfoBar from "@/components/navigation/InfoBar.vue";
import { useLayoutStore } from "@/stores/layout";
import { storeToRefs } from "pinia";

const layoutStore = useLayoutStore();

const { isMobileBrowser } = storeToRefs(layoutStore);
</script>

<template>
  <div class="main-layout">
    <InfoBar />
    <div class="main-navbar-plus-content-container">
      <NavigationBar />
      <main class="main-content-container" :class="{ mobile: isMobileBrowser }">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<style scoped>
@import "@/assets/base.css";
@import "@/assets/styles/layout.css";
@import "@/assets/styles/ui.css";
@import "@/assets/styles/navbars.css";

@mixin scrollbar-one .main-content-container;

.main-layout {
  min-height: 100vh;
  position: relative;
}
.main-navbar-plus-content-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
}
.main-content-container {
  padding: var(--layout-padding);
  margin-top: var(--layout-infobar-height);
  overflow-y: overlay;
  width: 100%;
  position: relative;
  background-color: var(--clr-grey-bg-main);
}

.main-content-container.mobile {
  margin-left: var(--navbar-width-phone);
}

@media (--max-tablet-width) {
  .main-content-container {
    padding: var(--layout-padding-phone);
    margin-top: var(--layout-infobar-height-phone);
  }
}
</style>
